import type { Feature, Point } from "./models";

export abstract class FeatureContainer {
  constructor(feature: Feature, isVisible: boolean, showLabel: boolean) { 
    this.feature = feature;
    this.isVisible = isVisible
    this.showLabel = showLabel
  }

  feature: Feature;
  isVisible: boolean
  showLabel: boolean

  abstract setEditable(isEdit: boolean, isSelected: boolean): void
  abstract getCoordinates(): Point[][]
  abstract setMap(map: google.maps.Map): void;
  abstract removeMap(): void;
  abstract clearEvents(): void;
  abstract highLight(): void;
  abstract unHighLight(): void;
}

export class PolygonContainer extends FeatureContainer {
    constructor(
      feature: Feature,
      isVisible: boolean,
      showLabel: boolean,
      polygon: google.maps.Polygon) {
      super(feature, isVisible, showLabel)

      this.polygon = polygon
    }
    polygon: google.maps.Polygon;
  
    override setEditable(isEdit: boolean, isSelected: boolean): void {
      this.polygon.setDraggable(isEdit)
      this.polygon.setEditable(isEdit)
      this.polygon.setOptions({ 
        strokeOpacity: isSelected ? 1: 0.5,
        fillOpacity: isSelected ? 0.3: 0.1})
    }
  
    override getCoordinates(): Point[][] {
      return [ [ ... this.polygon.getPath().getArray().map(x => ({ latitude: x.lat(), longitude: x.lng() }))] ]
    }
  
    override setMap(map: google.maps.Map) {
      this.polygon.setMap(map)
    }
  
    override removeMap() {
      this.polygon.setMap(null)
    }

    override clearEvents(): void {
      google.maps.event.clearInstanceListeners(this.polygon)
      this.polygon.getPaths().forEach(path => google.maps.event.clearInstanceListeners(path))
    }

    override highLight(): void {
        this.polygon.setOptions({ 
        strokeOpacity: 1,
        fillOpacity: 0.3})
    }

    override unHighLight(): void {
        this.polygon.setOptions({ 
        strokeOpacity: 0.5,
        fillOpacity: 0.1})
    }
}

export class AnnulusContainer extends FeatureContainer {
    constructor(
      feature: Feature,
      isVisible: boolean,
      showLabel: boolean,
      polygon: google.maps.Polygon) {
      super(feature, isVisible, showLabel)

      this.polygon = polygon
    }
    polygon: google.maps.Polygon;
  
    override setEditable(isEdit: boolean, isSelected: boolean): void {
      this.polygon.setDraggable(isEdit)
      this.polygon.setEditable(isEdit)
      this.polygon.setOptions({ 
        strokeOpacity: isSelected ? 1: 0.5,
        fillOpacity: isSelected ? 0.3: 0.1})
    }
  
    override getCoordinates(): Point[][] {
      return this.polygon.getPaths().getArray().map(c => c.getArray().map(x => ({ latitude: x.lat(), longitude: x.lng() })))
    }
  
    override setMap(map: google.maps.Map) {
      this.polygon.setMap(map)
    }
  
    override removeMap() {
      this.polygon.setMap(null)
    }

    override clearEvents(): void {
      google.maps.event.clearInstanceListeners(this.polygon)
      this.polygon.getPaths().forEach(path => google.maps.event.clearInstanceListeners(path))
    }

    override highLight(): void {
        this.polygon.setOptions({ 
        strokeOpacity: 1,
        fillOpacity: 0.3})
    }

    override unHighLight(): void {
        this.polygon.setOptions({ 
        strokeOpacity: 0.5,
        fillOpacity: 0.1})
    }
}

export class PolylineContainer extends FeatureContainer {
    constructor(
      feature: Feature,
      isVisible: boolean,
      showLabel: boolean,
      polygon: google.maps.Polyline) {
      super(feature, isVisible, showLabel)

      this.polyline = polygon
    }
    polyline: google.maps.Polyline;

  override setEditable(isEdit: boolean, isSelected: boolean): void {
    this.polyline.setDraggable(isEdit)
    this.polyline.setEditable(isEdit)
    this.polyline.setOptions({ 
      strokeOpacity: isSelected ? 1: 0.5,
      strokeWeight: isSelected ? 5 : 2
    })
  }

  override getCoordinates(): Point[][] {
    return [ [ ... this.polyline.getPath().getArray().map(x => ({ latitude: x.lat(), longitude: x.lng() }))] ]
  }

  override setMap(map: google.maps.Map) {
    this.polyline.setMap(map)
  }

  override removeMap() {
    this.polyline.setMap(null)
  }

  override clearEvents(): void {
    google.maps.event.clearInstanceListeners(this.polyline)
  }

  override highLight(): void {
      this.polyline.setOptions({ 
      strokeOpacity: 1})
  }

  override unHighLight(): void {
      this.polyline.setOptions({ 
      strokeOpacity: 0.5})
  }
}

export class PointContainer extends FeatureContainer {
    constructor(
      feature: Feature,
      isVisible: boolean,
      showLabel: boolean,
      point: google.maps.marker.AdvancedMarkerElement) {
      super(feature, isVisible, showLabel)

      this.point = point
    }

  point: google.maps.marker.AdvancedMarkerElement;

  override setEditable(isEdit: boolean): void {
    this.point.gmpClickable = isEdit
    this.point.gmpDraggable = isEdit
  }

  override getCoordinates(): Point[][] {
    return [ [ {latitude:  this.point.position!.lat as number, longitude: this.point.position!.lng as number} ] ]
  }

  override setMap(map: google.maps.Map) {
    this.point.map = map
  }

  override removeMap() {
    this.point.map = null
  }

  override clearEvents(): void {
    google.maps.event.clearInstanceListeners(this.point)
  }

  override highLight(): void {
      
  }

  override unHighLight(): void {
      
  }
}